/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const EmptyStateFolder140 = (props: SVGProps) => (
    <AccessibleSVG width={140} height={140} viewBox="0 0 140 140" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M47.11 36H35.383c-1.261 0-2.294.97-2.378 2.198L33 38.36v48.604c0 2.162 1.716 3.926 3.872 4.031l.546.005h.257l.19-.036c1.743-.375 3.062-1.86 3.152-3.663l.005-.197V73.972a.98.98 0 01.017-.18.87.87 0 01-.032-.155L41 73.52V56.717c0-4.209 3.7-7.59 8.268-7.713l.26-.004L97 48.999v-2.26c0-3.08-2.463-5.592-5.546-5.707l-.221-.004H54.118a4.402 4.402 0 01-3.51-1.738l-.14-.197-1.375-2.042a2.386 2.386 0 00-1.8-1.044L47.11 36z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                d="M51 96a7 7 0 110 14 7 7 0 010-14zm47-66c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M99 91a6 6 0 005.996-5.775L105 85V75h.005V56.717c0-2.983-2.624-5.472-6.005-5.708V51h-2v-.01H49.527c-3.55 0-6.403 2.476-6.528 5.518l-.004.209V73.52a.987.987 0 01-.024.219.91.91 0 01.022.12l.007.113v13.132a5.817 5.817 0 01-1.497 3.897L99 91z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M44.156 39c.466 0 .844.448.844 1s-.378 1-.844 1h-6.312c-.466 0-.844-.448-.844-1s.378-1 .844-1h6.312zm41.952 21c.493 0 .892.448.892 1s-.4 1-.892 1H61.892c-.493 0-.892-.448-.892-1s.4-1 .892-1h24.216z"
            />
            <path d="M79 93.5h7" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M82 77c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13zM47.113 34a4.4 4.4 0 013.509 1.739l.14.197 1.376 2.043c.407.607 1.073.99 1.799 1.045l.183.007h37.11c4.208 0 7.636 3.316 7.766 7.456l.004.244v2.284c4.358.24 7.863 3.449 7.996 7.464l.004.238V85a8 8 0 01-7.75 7.996L99 93a1 1 0 010-2 6 6 0 005.996-5.775L105 85V75h.005V56.717c0-2.983-2.624-5.472-6.005-5.708V51h-2v-.01H49.527c-3.55 0-6.403 2.476-6.528 5.518l-.004.209V73.52a.987.987 0 01-.024.219.91.91 0 01.022.12l.007.113v13.132a5.817 5.817 0 01-1.497 3.897L65 91a1 1 0 010 2H37c-3.238 0-5.878-2.521-5.996-5.675L31 87.104V38.347c0-2.33 1.85-4.232 4.174-4.342l.212-.005h11.727zm-.003 2H35.383c-1.261 0-2.294.97-2.378 2.198L33 38.36v48.604c0 2.162 1.716 3.926 3.872 4.031l.546.005h.257l.19-.036c1.743-.375 3.062-1.86 3.152-3.663l.005-.197V73.972a.98.98 0 01.017-.18.87.87 0 01-.032-.155L41 73.52V56.717c0-4.209 3.7-7.59 8.268-7.713l.26-.004L97 48.999v-2.26c0-3.08-2.463-5.592-5.546-5.707l-.221-.004H54.118a4.402 4.402 0 01-3.51-1.738l-.14-.197-1.375-2.042a2.386 2.386 0 00-1.8-1.044L47.11 36zm38.998 24c.493 0 .892.448.892 1s-.4 1-.892 1H61.892c-.493 0-.892-.448-.892-1s.4-1 .892-1h24.216zM44.156 39c.466 0 .844.448.844 1s-.378 1-.844 1h-6.312c-.466 0-.844-.448-.844-1s.378-1 .844-1h6.312z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M81.463 83.17a1.03 1.03 0 011.269.107l.09.095 4.932 5.898c.159.19.246.43.246.679 0 .542-.405.988-.925 1.045L86.96 91H85v4.92c0 .597-.496 1.081-1.11 1.081h-3.779c-.613 0-1.11-.484-1.11-1.08L79 91h-1.961c-.207 0-.408-.062-.578-.177l-.098-.076a1.06 1.06 0 01-.187-1.384l.074-.098 4.99-5.898.057-.061.061-.057.105-.08z"
            />
        </g>
    </AccessibleSVG>
);

export default EmptyStateFolder140;
